<template>
  <div
    class="response ua_yellow ua_blue fadein"
    v-show="form.payment_system === 'ukraine' && ua_maintenance"
  >
    {{ $t('shop.ua_manual_payment') }}
    <a href="https://t.me/dream_derp" target="_blank" style="font-weight: bold" class="ua_blue"
      >Telegram</a
    >
  </div>
  <div class="response success fadein" ref="response" v-show="response">
    {{ response }}
  </div>
  <div class="response error fadein" ref="errors" v-show="errors.length">
    <template v-for="(error, idx) in errors" :key="idx">
      <template v-if="errors.length > 1">
        <li>{{ error }}</li>
      </template>
      <template v-else>
        {{ error }}
      </template>
    </template>
  </div>
  <div class="response warning fadein" ref="response_url" v-show="response_url">
    {{ $t('shop.popup_blocked') }}
    <a :href="response_url" target="_blank" style="font-weight: bold; color: red">{{
      $t('shop.click_here')
    }}</a>
  </div>
  <div class="loader" v-if="loading"></div>
  <form
    class="form"
    data-gw-tab="shop"
    data-gw-tab-grp="form"
    @submit.prevent="form_submit"
    ref="form"
  >
    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__helmet.png" class="field__ico_w-24" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.character') }}</div>
      </div>
      <template v-if="logged_in && characters[form_server_c].length">
        <select
          name="character"
          v-model="form_character_c"
          class="tt-uppercase"
          ref="account_character_list"
          required
        >
          <option
            v-for="(character, index) in characters[form_server_c]"
            :key="index"
            :value="character.char_name"
          >
            {{ character.char_name }}
          </option>
        </select>
      </template>
      <template v-else>
        <input type="text" class="input" name="character" v-model="form_character_c" required />
      </template>
    </div>

    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__mail.png" alt="email" />
        </div>
        <div class="field__title">{{ $t('shop.email') }}</div>
      </div>
      <input type="email" class="input" name="email" v-model="form.email" required />
    </div>

    <div class="field field_grp field_mb" v-if="this.form.payment_system === 'interkassa'">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__user.png" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.first_name') }}</div>
      </div>
      <input
        type="text"
        class="input"
        name="first_name"
        maxlength="64"
        v-model="form_first_name_c"
        required
      />
    </div>

    <div class="field field_grp field_mb" v-if="this.form.payment_system === 'interkassa'">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__user.png" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.last_name') }}</div>
      </div>
      <input
        type="text"
        class="input"
        name="last_name"
        maxlength="64"
        v-model="form_last_name_c"
        required
      />
    </div>

    <div class="field field_grp field_mb" v-if="this.form.payment_system === 'interkassa'">
      <div class="field__desc">
        <div class="field__ico">
          <img
            src="@/assets/images/icons/ico__phone.png"
            class="field__ico_w-24"
            alt="Phone number"
          />
        </div>
        <div class="field__title">{{ $t('shop.phone') }}</div>
      </div>
      <input type="tel" class="input" name="phone" maxlength="24" v-model="form_phone_c" required />
    </div>

    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__coin_val_euro.png" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.coins') }}</div>
      </div>
      <input
        v-model="form.coins"
        name="coins"
        type="number"
        :min="calc_min_coins"
        max="99999"
        maxlength="5"
        class="input"
        required
      />
      <div
        class="field__box field__box_prl field__box_bl field__box_color_grey price-width"
        :title="$t('shop.bonus_coins')"
      >
        <template v-if="price > 0"> + {{ calculate_bonus }}</template>
        <template v-else> + 0</template>
      </div>
      <div
        class="field__box field__box_prl field__box_bl field__box_color_grey price-width"
        :title="$t('shop.price')"
      >
        ~ {{ price }}
      </div>
      <div class="field__box field__box_prl field__box_bl field__box_color_grey">
        <img src="@/assets/images/icons/val__euro.png" alt="" />
      </div>
    </div>

    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__flag.png" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.server') }}</div>
      </div>
      <select name="server" class="tt-uppercase" v-model="form_server_c">
        <option
          v-for="(server, index) in servers"
          :key="index"
          :value="server.id"
          :disabled="server.status === 'off' && this.env === 'production'"
          translate="no"
        >
          {{ server.name }} x{{ server.rate }}
        </option>
      </select>
    </div>

    <div class="field field_grp field_mb">
      <div class="field__desc">
        <div class="field__ico">
          <img src="@/assets/images/icons/ico__purse.png" alt="" />
        </div>
        <div class="field__title">{{ $t('shop.method') }}</div>
      </div>
      <select
        name="payment_system"
        v-model="form.payment_system"
        class="tt-uppercase"
        :disabled="payment_systems_loading || payment_systems.length === 0"
      >
        <option v-if="payment_systems_loading" disabled>
          {{ $t('shop.loading_payment_systems') || 'Loading...' }}
        </option>
        <option v-else-if="payment_systems.length === 0" disabled>
          {{ $t('shop.no_payment_systems') || 'No payment methods available' }}
        </option>
        <template v-else v-for="(payment_system, index) in payment_systems_c" :key="index">
          <option
            :value="payment_system.key"
            v-if="payment_system.key === 'apple_pay' || !payment_system.disabled"
            :disabled="payment_system.disabled"
            translate="no"
          >
            {{ payment_system.name }}
          </option>
        </template>
      </select>
    </div>

    <template v-if="this.env === 'production'">
      <div class="protection protection_mb">
        <div class="protection__captcha">
          <vue-recaptcha
            v-show="showRecaptcha"
            :sitekey="recaptcha_sitekey"
            size="normal"
            theme="dark"
            :tabindex="0"
            @verify="recaptchaVerified"
            @expire="recaptchaExpired"
            @fail="recaptchaFailed"
            ref="vueRecaptcha"
          >
          </vue-recaptcha>
        </div>
      </div>
    </template>

    <div class="agreement agreement_mb" v-show="form.payment_system === 'g2a_com'" data-rules="g2a">
      <div class="agreement__box">
        <div class="agreement__check agreement__check_left">
          <input
            type="checkbox"
            name="g2a_agreement"
            v-model="form.g2a_agreement"
            :required="form.payment_system === 'g2a_com'"
          />
        </div>
        <div class="agreement__content">
          <a href="/g2a_agreement" target="_blank" class="agreement__link">{{
            $t('shop.g2a_agreement')
          }}</a>
        </div>
      </div>
    </div>

    <div class="agreement agreement_mb">
      <div class="agreement__box">
        <div class="agreement__check agreement__check_left">
          <input type="checkbox" name="user_agreement" v-model="form.user_agreement" required />
        </div>
        <div class="agreement__content">
          <a
            href="/user_agreement"
            target="_blank"
            class="agreement__link"
            data-inner-select="user_agreement"
            >{{ $t('shop.user_agreement') }}</a
          >
        </div>
      </div>
    </div>

    <div
      v-show="this.paypal_payment_systems.indexOf(form.payment_system) !== -1"
      ref="paypal"
    ></div>

    <div class="form__btn-box" data-shop-btn v-show="!isWalletPaymentSelected">
      <button
        class="button"
        type="submit"
        :class="{ disabled: btn_disabled }"
        :disabled="btn_disabled"
      >
        <span class="button__content">{{ $t('shop.pay') }}</span>
      </button>
    </div>
  </form>

  <!-- Google Pay Button -->
  <div class="google-pay-section" v-show="isGooglePaySelected">
    <div v-if="googlePayLoading" class="payment-loading">
      <Loading />
    </div>
    <div v-else-if="sdkInitState.status === 'failed'" class="google-pay-unavailable">
      <span class="google-pay-unavailable-icon">⚠️</span>
      <span>{{ $t('shop2.google_pay_unavailable') }}</span>
    </div>
    <template v-else-if="googlePayAvailable">
      <div id="google-pay-button" class="google-pay-button-container"></div>
    </template>
    <div v-else class="google-pay-unavailable">
      <span class="google-pay-unavailable-icon">⚠️</span>
      <span>{{ googlePayUnavailableMessage }}</span>
    </div>
  </div>

  <!-- Apple Pay Button -->
  <div class="apple-pay-section" v-show="isApplePaySelected">
    <div v-if="googlePayLoading" class="payment-loading">
      <Loading />
    </div>
    <template v-else-if="applePayAvailable">
      <div id="apple-pay-button-container" class="apple-pay-button-container"></div>
    </template>
    <div v-else class="google-pay-unavailable">
      <span class="google-pay-unavailable-icon">⚠️</span>
      <span>{{ applePayUnavailableMessage }}</span>
    </div>
  </div>

  <!-- PayPal v6 Button -->
  <div class="paypal-v6-section" v-show="isPayPalV6Selected">
    <div v-if="googlePayLoading" class="payment-loading">
      <Loading />
    </div>
    <template v-else-if="paypalV6Available">
      <div id="paypal-v6-button" class="paypal-v6-button-container"></div>
    </template>
    <div v-else class="google-pay-unavailable">
      <span class="google-pay-unavailable-icon">⚠️</span>
      <span>{{ $t('shop2.paypal_initializing') }}</span>
    </div>
  </div>
</template>

<script>
/* global ApplePaySession */
import axios from 'axios';
import cfg_axios from '@/config/cfg_axios';
import vueRecaptcha from 'vue3-recaptcha2';
import { recaptcha_sitekey } from '@/assets/js/recaptcha';
import Loading from '@/components/Loading.vue';
import PaymentSystemLogger from '@/services/PaymentSystemLogger';
import {
  CONFIG_KEY as CHARACTER_NAME_CONFIG_KEY,
  DEFAULT_RULES as CHARACTER_NAME_DEFAULT_RULES,
  buildCharacterNameRegex,
  normalizeRules as normalizeCharacterNameRules,
} from '@/assets/js/characterNameRegex';
const WALLET_PAYMENT_HANDLERS = Object.freeze({
  google_pay: 'onGooglePayButtonClick',
  apple_pay: 'onApplePayButtonClick',
  paypal_v6: 'onPayPalV6ButtonClick',
});

export default {
  name: 'Shop',
  components: {
    vueRecaptcha,
    Loading,
  },
  data() {
    return {
      recaptcha_sitekey,
      showRecaptcha: true,
      captcha: false,
      price_rub: 60,
      price_eur: 0.5,
      response: null,
      response_url: null,
      errors: [],
      btn_disabled: false,
      paidFor: false,
      loaded: false,
      ua_maintenance: false,
      item: {
        name: this.$t('shop.coin_of_luck'),
        description: this.$t('shop.in_game_currency'),
      },
      paypal_default_currency: 'EUR',
      paypal_client_id:
        'ATlV0QTWlBheZS0t4F9Tb_YCiUaR9BpkfmJJZ5tQtTuxsCzGphpas3TpFnilD7Q3GDiBhwtcUhfQvBzB',
      form: {
        character: null,
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
        coins: 50,
        server: 5,
        payment_system: 'paypal_v2',
        user_agreement: false,
        g2a_agreement: false,
      },
      payment_systems: [],
      payment_systems_loading: false,
      paypal_payment_systems: [
        'paypal',
        'card',
        'credit',
        'venmo',
        'sepa',
        'bancontact',
        'eps',
        'giropay',
        'ideal',
        'mercadopago',
        'mybank',
        'p24',
        'sofort',
      ],
      googlePayAvailable: false,
      applePayAvailable: false,
      paypalV6Available: false,
      scriptsState: {
        googlePay: 'pending',
        paypalSdk: 'pending',
        applePaySdk: 'pending',
      },
      googlePayLoading: false,
      sdkInitState: {
        status: 'idle',
        attempts: 0,
        maxAttempts: 3,
        lastError: null,
      },
    };
  },
  computed: {
    loading() {
      return this.$store.getters.get_modal_loading;
    },
    calc_min_coins() {
      switch (this.form.payment_system) {
        case 'interkassa':
          return 2;
        case 'enot_v2':
          return 2;
        case 'prime_payments':
          return 2;
        case 'pally':
          return 6;
        default:
          return 1;
      }
    },
    env() {
      return process.env.VUE_APP_ENV;
    },
    calculate_bonus() {
      let coins = this.form.coins;
      let bonus = 1;
      if (coins >= 50 && coins < 100) {
        bonus = 1.1;
      } else if (coins >= 100 && coins < 500) {
        bonus = 1.2;
      } else if (coins >= 500 && coins < 1000) {
        bonus = 1.3;
      } else if (coins >= 1000 && coins < 5000) {
        bonus = 1.4;
      } else if (coins >= 5000) {
        bonus = 1.5;
      }
      return Math.round(this.form.coins * bonus) % this.form.coins;
    },
    bonus_available() {
      return this.form.coins >= 50;
    },
    get_default_server() {
      return this.$store.getters.get_default_server;
    },
    price() {
      return (this.form.coins * this.$store.getters.get_price).toFixed(2);
    },
    payment_systems_c() {
      return this.payment_systems.map(ps => {
        if (ps.key === 'google_pay') {
          return { ...ps, disabled: !this.googlePayAvailable };
        }
        if (ps.key === 'apple_pay') {
          return { ...ps, disabled: !this.applePayAvailable };
        }
        if (ps.key === 'paypal_v6') {
          return { ...ps, disabled: !this.paypalV6Available };
        }
        return ps;
      });
    },
    servers() {
      return this.$store.getters.get_servers;
    },
    logged_in() {
      return this.$store.getters.get_logged_in;
    },
    form_character_c: {
      get() {
        return this.form.character;
      },
      set(value) {
        this.form.character = value;
      },
    },
    form_first_name_c: {
      get() {
        return this.form.first_name;
      },
      set(value) {
        this.form.first_name = value;
      },
    },
    form_last_name_c: {
      get() {
        return this.form.last_name;
      },
      set(value) {
        this.form.last_name = value;
      },
    },
    form_phone_c: {
      get() {
        return this.form.phone;
      },
      set(value) {
        this.form.phone = value;
      },
    },
    form_server_c: {
      get() {
        return this.form.server;
      },
      set(value) {
        this.form.server = value;
      },
    },
    characters() {
      return this.$store.getters.get_characters;
    },
    isGooglePaySelected() {
      return this.form.payment_system === 'google_pay';
    },
    isApplePaySelected() {
      return this.form.payment_system === 'apple_pay';
    },
    isPayPalV6Selected() {
      return this.form.payment_system === 'paypal_v6';
    },
    isWalletPaymentSelected() {
      return this.isGooglePaySelected || this.isApplePaySelected || this.isPayPalV6Selected;
    },
    googlePayUnavailableMessage() {
      if (this.sdkInitState.status === 'failed') {
        return this.$t('shop2.gpay_sdk_failed');
      }
      if (!window.google?.payments?.api) {
        return this.$t('shop2.gpay_sdk_unavailable');
      }
      return this.$t('shop2.gpay_not_eligible');
    },
    applePayUnavailableMessage() {
      if (!window.ApplePaySession) {
        return this.$t('shop2.apay_requires_safari');
      }
      if (!this.safeApplePayCanMakePayments()) {
        return this.$t('shop2.apay_no_wallet');
      }
      return this.$t('shop2.apay_unavailable');
    },
    character_name_rules() {
      const config = this.$store.getters.get_config;
      const entry = config?.public?.find(item => item.key === CHARACTER_NAME_CONFIG_KEY);
      if (!entry?.value) return CHARACTER_NAME_DEFAULT_RULES;
      return normalizeCharacterNameRules(entry.value);
    },
    character_name_regex() {
      return buildCharacterNameRegex(this.character_name_rules);
    },
    formValidation() {
      const errors = {};
      if (!this.form_character_c) {
        errors.character = this.$t('shop2.character_required');
      } else if (!this.character_name_regex.test(this.form_character_c)) {
        errors.character = this.$t('shop2.character_invalid');
      }
      if (!this.form.email) {
        errors.email = this.$t('shop2.email_required');
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.email)) {
          errors.email = this.$t('shop2.email_invalid');
        }
      }
      if (!this.form.coins) {
        errors.coins = this.$t('shop2.coins_required');
      } else if (this.form.coins < this.calc_min_coins || this.form.coins > 99999) {
        errors.coins = this.$t('shop2.coins_range', { min: this.calc_min_coins, max: 99999 });
      }
      if (!this.form_server_c) {
        errors.server = this.$t('shop2.server_required');
      }
      if (!this.form.user_agreement) {
        errors.user_agreement = this.$t('shop2.agree_terms');
      }
      if (this.form.payment_system === 'g2a_com' && !this.form.g2a_agreement) {
        errors.g2a_agreement = this.$t('shop2.agree_g2a');
      }
      return { valid: Object.keys(errors).length === 0, errors };
    },
    isFormValid() {
      return this.formValidation.valid;
    },
    formErrorMessages() {
      return Object.values(this.formValidation.errors);
    },
  },
  watch: {
    'form.payment_system': {
      handler(newValue) {
        if (newValue === 'google_pay') {
          this.$nextTick(() => {
            this.ensureGooglePayButton();
          });
        } else if (newValue === 'apple_pay') {
          this.$nextTick(() => {
            this.ensureApplePayButton();
          });
        }
      },
    },
  },
  mounted() {
    if (this.$store.getters.get_default_server) {
      if (this.servers?.[this.$store.getters.get_default_server - 1]?.status === 'on') {
        this.form.server = parseInt(this.$store.getters.get_default_server);
      } else {
        this.form.server = 1;
      }
    }
    this.fetchPaymentSystems();
    this.loadSDKScripts();
  },
  beforeUnmount() {
    if (this._observers) {
      Object.keys(this._observers).forEach(id => {
        if (this._observers[id]) this._observers[id].disconnect();
      });
      this._observers = null;
    }
    if (this._retryTimer) {
      clearTimeout(this._retryTimer);
      this._retryTimer = null;
    }
  },
  methods: {
    // ─── Payment systems list ──────────────────────────────────────────────
    async fetchPaymentSystems() {
      this.payment_systems_loading = true;
      try {
        const response = await axios.get(cfg_axios.base_url + '/config/paymentSystems', {
          headers: cfg_axios.headers,
        });
        if (response.data && response.data.payment_systems) {
          this.payment_systems = response.data.payment_systems.map(system => ({
            key: system.key || system.name,
            name: (
              system.label || this.getPaymentSystemTranslation(system.key || system.name)
            ).replace(/_/g, ' '),
            disabled: system.disabled || false,
          }));
          if (this.payment_systems.length > 0) {
            const currentSystemAvailable = this.payment_systems.some(
              ps => ps.key === this.form.payment_system && !ps.disabled
            );
            if (!currentSystemAvailable) {
              const firstAvailable = this.payment_systems.find(ps => !ps.disabled);
              if (firstAvailable) {
                this.form.payment_system = firstAvailable.key;
              }
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch payment systems:', error);
        this.payment_systems = [];
      } finally {
        this.payment_systems_loading = false;
      }
    },
    getPaymentSystemTranslation(systemKey) {
      const translationMap = {
        paypal: this.$t('shop.payment_paypal'),
        paypal_v2: this.$t('shop.payment_paypal'),
        stripe: this.$t('shop.payment_stripe'),
        morune: this.$t('shop.payment_morune'),
        zen: this.$t('shop.payment_zen'),
        pally: this.$t('shop.payment_pally'),
        freekassa_new_rub: this.$t('shop.payment_freekassa'),
        ukraine: this.$t('shop.payment_ukraine'),
        payop: this.$t('shop.payment_payop'),
        prime_payments: this.$t('shop.payment_prime_payments'),
        enot_v2: this.$t('shop.payment_enot'),
        paymentwall: this.$t('shop.payment_paymentwall'),
        interkassa: this.$t('shop.payment_interkassa'),
        google_pay: 'Google Pay',
        apple_pay: 'Apple Pay',
        paypal_v6: 'PayPal',
      };
      return translationMap[systemKey] || (systemKey ? systemKey.toUpperCase() : '');
    },

    // ─── SDK loading ───────────────────────────────────────────────────────
    loadSDKScripts() {
      const paypalEnv = process.env.VUE_APP_ENV === 'production' ? 'www' : 'www.sandbox';
      const googlePayUrl = 'https://pay.google.com/gp/p/js/pay.js';
      const paypalSdkUrl = `https://${paypalEnv}.paypal.com/web-sdk/v6/core`;
      const applePaySdkUrl = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

      this.scriptsState.googlePay = 'loading';
      this.scriptsState.paypalSdk = 'loading';
      this.googlePayLoading = true;

      const googlePayScript = this.createScript(
        googlePayUrl,
        () => {
          this.scriptsState.googlePay = 'loaded';
          PaymentSystemLogger.info('google_pay', 'sdk_loaded');
          this.checkAndInitialize();
        },
        () => {
          this.scriptsState.googlePay = 'error';
          PaymentSystemLogger.error('google_pay', 'sdk_load_failed', { url: googlePayUrl });
          this.googlePayAvailable = false;
          this.googlePayLoading = false;
        }
      );

      const paypalScript = this.createScript(
        paypalSdkUrl,
        () => {
          this.scriptsState.paypalSdk = 'loaded';
          PaymentSystemLogger.info('paypal_v6', 'sdk_loaded');
          this.checkAndInitialize();
        },
        () => {
          this.scriptsState.paypalSdk = 'error';
          PaymentSystemLogger.error('paypal_v6', 'sdk_load_failed', { url: paypalSdkUrl });
          this.paypalV6Available = false;
          this.googlePayLoading = false;
        }
      );

      document.head.appendChild(googlePayScript);
      document.head.appendChild(paypalScript);

      // Apple Pay JS SDK: only needed on Safari/iOS/macOS. Adds <apple-pay-button> custom element.
      if (window.ApplePaySession) {
        this.scriptsState.applePaySdk = 'loading';
        const applePayScript = this.createScript(
          applePaySdkUrl,
          () => {
            this.scriptsState.applePaySdk = 'loaded';
            PaymentSystemLogger.info('apple_pay', 'sdk_loaded');
          },
          () => {
            this.scriptsState.applePaySdk = 'error';
            PaymentSystemLogger.error('apple_pay', 'sdk_load_failed', { url: applePaySdkUrl });
            this.applePayAvailable = false;
          }
        );
        applePayScript.crossOrigin = 'anonymous';
        document.head.appendChild(applePayScript);
      } else {
        this.scriptsState.applePaySdk = 'skipped';
      }
    },

    createScript(src, onLoad, onError) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = onLoad;
      script.onerror = onError;
      return script;
    },

    checkAndInitialize() {
      if (this.scriptsState.googlePay === 'loaded' && this.scriptsState.paypalSdk === 'loaded') {
        this.initializeWithRetry();
      }
    },

    async initializeWithRetry() {
      const { maxAttempts } = this.sdkInitState;
      this.sdkInitState.attempts = 0;
      this.sdkInitState.lastError = null;

      while (this.sdkInitState.attempts < maxAttempts) {
        this.sdkInitState.attempts++;
        this.sdkInitState.status = 'initializing';
        try {
          await this.initializePayPalV6SDK();
          this.sdkInitState.status = 'ready';
          this.googlePayLoading = false;
          PaymentSystemLogger.info('paypal_v6', 'sdk_initialized', {
            attempts: this.sdkInitState.attempts,
          });
          return;
        } catch (err) {
          this.sdkInitState.lastError = err;
          PaymentSystemLogger.error('paypal_v6', 'sdk_init_attempt_failed', {
            attempt: this.sdkInitState.attempts,
            maxAttempts,
            error: { name: err.name, message: err.message, stack: err.stack },
          });
          if (this.sdkInitState.attempts < maxAttempts) {
            await this.delay(Math.pow(2, this.sdkInitState.attempts) * 1000);
          }
        }
      }

      PaymentSystemLogger.error('paypal_v6', 'sdk_init_failed_all_attempts', {
        attempts: this.sdkInitState.attempts,
      });
      this.sdkInitState.status = 'failed';
      this.googlePayAvailable = false;
      this.googlePayLoading = false;
    },

    async getBrowserSafeClientToken() {
      const response = await axios.get(
        `${cfg_axios.base_url}/paypal/auth/browser-safe-client-token`,
        { headers: cfg_axios.headers }
      );
      return response.data.accessToken;
    },

    async initializePayPalV6SDK() {
      const clientToken = await this.getBrowserSafeClientToken();
      const components = ['googlepay-payments', 'applepay-payments', 'paypal-payments'];
      const sdkInstance = await window.paypal.createInstance({
        clientToken,
        components,
        pageType: 'checkout',
      });
      this._paypalSdkInstance = sdkInstance;

      await Promise.allSettled([
        this.setupGooglePayButton(sdkInstance),
        this.setupApplePayButton(sdkInstance),
        this.setupPayPalV6Button(sdkInstance),
      ]);

      this.googlePayLoading = false;
    },

    // ─── Google Pay ────────────────────────────────────────────────────────
    async setupGooglePayButton(sdkInstance) {
      try {
        const googlePaySession = sdkInstance.createGooglePayOneTimePaymentSession();
        this._googlePaySession = googlePaySession;

        const googlePayConfig = await googlePaySession.getGooglePayConfig();
        this._googlePayConfig = JSON.parse(JSON.stringify(googlePayConfig));

        const self = this;
        const environment = process.env.VUE_APP_ENV === 'production' ? 'PRODUCTION' : 'TEST';

        const paymentsClient = new window.google.payments.api.PaymentsClient({
          environment,
          paymentDataCallbacks: {
            onPaymentAuthorized(paymentData) {
              return self.onPaymentAuthorized(paymentData, googlePaySession);
            },
          },
        });

        const isReadyToPayRequest = {
          allowedPaymentMethods: googlePayConfig.allowedPaymentMethods,
          apiVersion: googlePayConfig.apiVersion,
          apiVersionMinor: googlePayConfig.apiVersionMinor,
        };
        const isReadyToPay = await paymentsClient.isReadyToPay(isReadyToPayRequest);

        if (isReadyToPay.result) {
          this.googlePayAvailable = true;
          this._paymentsClient = paymentsClient;
          PaymentSystemLogger.info('google_pay', 'setup_success', { environment });
          this.addGooglePayButton(paymentsClient);
        } else {
          PaymentSystemLogger.warn('google_pay', 'setup_not_ready_to_pay', { environment });
          this.googlePayAvailable = false;
        }
      } catch (err) {
        PaymentSystemLogger.error('google_pay', 'setup_failed', err);
        this.googlePayAvailable = false;
      }
    },

    addGooglePayButton(paymentsClient) {
      try {
        if (!window.google) return;
        const container = document.getElementById('google-pay-button');
        if (!container) {
          this.waitForContainer('google-pay-button', () => this.addGooglePayButton(paymentsClient));
          return;
        }
        if (container.querySelector('button, .gpay-button')) return;

        const button = paymentsClient.createButton({
          onClick: () => this.onGooglePayButtonClick(),
          buttonColor: 'black',
          buttonType: 'buy',
        });
        button.setAttribute('type', 'button');
        container.appendChild(button);
        PaymentSystemLogger.info('google_pay', 'button_rendered');
      } catch (err) {
        PaymentSystemLogger.error('google_pay', 'button_render_failed', err);
      }
    },

    ensureGooglePayButton() {
      if (!this.googlePayAvailable || !this._paymentsClient) return;
      const container = document.getElementById('google-pay-button');
      if (!container) {
        this.waitForContainer('google-pay-button', () =>
          this.addGooglePayButton(this._paymentsClient)
        );
        return;
      }
      if (!container.querySelector('button, .gpay-button')) {
        this.addGooglePayButton(this._paymentsClient);
      }
    },

    getGooglePaymentDataRequest() {
      if (!this._googlePayConfig) throw new Error('Google Pay config not available');
      const config = this._googlePayConfig;
      return {
        apiVersion: config.apiVersion,
        apiVersionMinor: config.apiVersionMinor,
        allowedPaymentMethods: config.allowedPaymentMethods,
        transactionInfo: {
          countryCode: config.countryCode || 'US',
          currencyCode: 'EUR',
          totalPriceStatus: 'FINAL',
          totalPrice: this.price.toString(),
          totalPriceLabel: this.$t('shop2.total'),
        },
        merchantInfo: config.merchantInfo,
        callbackIntents: ['PAYMENT_AUTHORIZATION'],
      };
    },

    async onGooglePayButtonClick() {
      this.errors = [];
      this.response = null;
      this.response_url = null;

      PaymentSystemLogger.info('google_pay', 'button_click', {
        isFormValid: this.isFormValid,
        isReady: this.isWalletPaymentReady('google_pay'),
      });

      if (!this.isFormValid) {
        PaymentSystemLogger.warn('google_pay', 'form_invalid', {
          errors: this.formErrorMessages,
        });
        this.errors = this.formErrorMessages;
        return;
      }

      if (!this.isWalletPaymentReady('google_pay')) {
        PaymentSystemLogger.warn('google_pay', 'wallet_not_ready', {
          googlePayAvailable: this.googlePayAvailable,
          hasSession: !!this._googlePaySession,
          hasConfig: !!this._googlePayConfig,
          hasClient: !!this._paymentsClient,
        });
        this.errors = [this.$t('shop2.google_pay_initializing')];
        return;
      }

      this.$store.dispatch('set_modal_loading', true);
      this.btn_disabled = true;

      try {
        const paymentDataRequest = this.getGooglePaymentDataRequest();
        PaymentSystemLogger.info('google_pay', 'load_payment_data', { paymentDataRequest });
        await this._paymentsClient.loadPaymentData(paymentDataRequest);
      } catch (err) {
        this.$store.dispatch('set_modal_loading', false);
        this.btn_disabled = false;
        if (err.statusCode === 'CANCELED') {
          PaymentSystemLogger.info('google_pay', 'user_cancelled');
          return;
        }
        PaymentSystemLogger.error('google_pay', 'load_payment_data_failed', err);
        this.displayPaymentError(err);
      }
    },

    async onPaymentAuthorized(paymentData, googlePaySession) {
      PaymentSystemLogger.info('google_pay', 'payment_authorized');
      try {
        const orderPayload = this.getPayPalOrderPayload('google_pay');
        const orderResponse = await this.createWalletOrder(orderPayload);
        const orderId = orderResponse.id;
        PaymentSystemLogger.info('google_pay', 'order_created', { orderId });

        const { status } = await googlePaySession.confirmOrder({
          orderId,
          paymentMethodData: paymentData.paymentMethodData,
        });
        PaymentSystemLogger.info('google_pay', 'order_confirmed', { orderId, status });

        if (status === 'PAYER_ACTION_REQUIRED') {
          await googlePaySession.initiatePayerAction({ orderId });
          await this.captureWalletOrder(orderId);
        } else {
          await this.captureWalletOrder(orderId);
        }
        PaymentSystemLogger.info('google_pay', 'order_captured', { orderId });

        const coinsWithBonus = parseInt(this.form.coins) + this.calculate_bonus;
        this.response = this.$t('shop2.success_payment', {
          orderId,
          coins: coinsWithBonus,
          character: this.form_character_c,
        });
        this.$store.dispatch('set_modal_loading', false);
        this.btn_disabled = false;
        return { transactionState: 'SUCCESS' };
      } catch (err) {
        PaymentSystemLogger.error('google_pay', 'payment_authorized_failed', err);
        this.$store.dispatch('set_modal_loading', false);
        this.btn_disabled = false;
        this.displayPaymentError(err);
        return { transactionState: 'ERROR', error: { message: err.message } };
      }
    },

    // ─── Apple Pay ─────────────────────────────────────────────────────────
    async setupApplePayButton(sdkInstance) {
      try {
        if (!window.ApplePaySession || !this.safeApplePayCanMakePayments()) {
          PaymentSystemLogger.info('apple_pay', 'setup_skipped_unsupported_device', {
            hasApplePaySession: !!window.ApplePaySession,
            canMakePayments: this.safeApplePayCanMakePayments(),
          });
          this.applePayAvailable = false;
          return;
        }

        const paymentMethods = await sdkInstance.findEligibleMethods({ currencyCode: 'EUR' });
        if (!paymentMethods.isEligible('applepay')) {
          PaymentSystemLogger.warn('apple_pay', 'setup_not_eligible');
          this.applePayAvailable = false;
          return;
        }

        const details = paymentMethods.getDetails('applepay');
        const applePaySession = sdkInstance.createApplePayOneTimePaymentSession();
        this._applePaySession = applePaySession;
        this._applePayDetails = details;
        this.applePayAvailable = true;
        PaymentSystemLogger.info('apple_pay', 'setup_success', {
          config: details?.config,
        });
        this.addApplePayButton();
      } catch (err) {
        PaymentSystemLogger.error('apple_pay', 'setup_failed', err);
        this.applePayAvailable = false;
      }
    },

    async addApplePayButton() {
      try {
        await this.$nextTick();
        const container = document.getElementById('apple-pay-button-container');
        if (!container) {
          this.waitForContainer('apple-pay-button-container', () => this.addApplePayButton());
          return;
        }
        if (container.querySelector('apple-pay-button')) return;
        container.innerHTML = '';
        const button = document.createElement('apple-pay-button');
        button.id = 'apple-pay-button';
        button.setAttribute('buttonstyle', 'black');
        button.setAttribute('type', 'buy');
        button.setAttribute('locale', 'en-US');
        button.addEventListener('click', () => this.onApplePayButtonClick());
        container.appendChild(button);
        PaymentSystemLogger.info('apple_pay', 'button_rendered');
      } catch (err) {
        PaymentSystemLogger.error('apple_pay', 'button_render_failed', err);
      }
    },

    ensureApplePayButton() {
      if (!this.applePayAvailable) return;
      const container = document.getElementById('apple-pay-button-container');
      if (!container) {
        this.waitForContainer('apple-pay-button-container', () => this.addApplePayButton());
        return;
      }
      if (!container.querySelector('apple-pay-button')) {
        this.addApplePayButton();
      }
    },

    async onApplePayButtonClick() {
      this.errors = [];
      this.response = null;

      PaymentSystemLogger.info('apple_pay', 'button_click', {
        isFormValid: this.isFormValid,
        isReady: this.isWalletPaymentReady('apple_pay'),
        hasApplePaySession: !!window.ApplePaySession,
      });

      if (!this.isFormValid) {
        PaymentSystemLogger.warn('apple_pay', 'form_invalid', {
          errors: this.formErrorMessages,
        });
        this.errors = this.formErrorMessages;
        return;
      }
      if (!this.isWalletPaymentReady('apple_pay')) {
        PaymentSystemLogger.warn('apple_pay', 'wallet_not_ready', {
          applePayAvailable: this.applePayAvailable,
          hasSession: !!this._applePaySession,
          hasDetails: !!this._applePayDetails?.config,
        });
        this.errors = [this.$t('shop2.apple_pay_initializing')];
        return;
      }

      this.$store.dispatch('set_modal_loading', true);
      this.btn_disabled = true;

      try {
        const paypalSession = this._applePaySession;
        const applePayConfig = this._applePayDetails?.config || {};
        const formatted = paypalSession.formatConfigForPaymentRequest(applePayConfig) || {};
        const paymentRequest = {
          ...formatted,
          countryCode: formatted.countryCode || applePayConfig.countryCode || 'US',
          currencyCode: 'EUR',
          merchantCapabilities: formatted.merchantCapabilities ||
            applePayConfig.merchantCapabilities || ['supports3DS'],
          supportedNetworks: formatted.supportedNetworks ||
            applePayConfig.supportedNetworks || ['visa', 'masterCard', 'amex'],
          requiredBillingContactFields: ['name', 'email', 'postalAddress'],
          requiredShippingContactFields: [],
          total: {
            label: `${this.item.name} x${this.form.coins}`,
            amount: this.price.toString(),
            type: 'final',
          },
        };

        PaymentSystemLogger.info('apple_pay', 'payment_request_built', { paymentRequest });

        const appleSdkSession = new ApplePaySession(4, paymentRequest);
        const self = this;

        appleSdkSession.onvalidatemerchant = event => {
          PaymentSystemLogger.info('apple_pay', 'onvalidatemerchant', {
            validationURL: event.validationURL,
          });
          paypalSession
            .validateMerchant({ validationUrl: event.validationURL })
            .then(payload => {
              PaymentSystemLogger.info('apple_pay', 'merchant_validated', {
                hasSession: !!payload?.merchantSession,
              });
              appleSdkSession.completeMerchantValidation(payload.merchantSession);
            })
            .catch(err => {
              PaymentSystemLogger.error('apple_pay', 'validate_merchant_failed', err);
              appleSdkSession.abort();
              self.errors = [self.$t('shop2.apay_unavailable')];
              self.$store.dispatch('set_modal_loading', false);
              self.btn_disabled = false;
            });
        };

        appleSdkSession.onpaymentmethodselected = () => {
          PaymentSystemLogger.info('apple_pay', 'payment_method_selected');
          appleSdkSession.completePaymentMethodSelection({ newTotal: paymentRequest.total });
        };

        appleSdkSession.onpaymentauthorized = async event => {
          PaymentSystemLogger.info('apple_pay', 'payment_authorized');
          try {
            const orderPayload = self.getPayPalOrderPayload('apple_pay');
            const orderResponse = await self.createWalletOrder(orderPayload);
            const orderId = orderResponse.id;
            PaymentSystemLogger.info('apple_pay', 'order_created', { orderId });
            await paypalSession.confirmOrder({
              orderId,
              token: event.payment.token,
              billingContact: event.payment.billingContact,
              shippingContact: event.payment.shippingContact,
            });
            PaymentSystemLogger.info('apple_pay', 'order_confirmed', { orderId });
            await self.captureWalletOrder(orderId);
            PaymentSystemLogger.info('apple_pay', 'order_captured', { orderId });
            appleSdkSession.completePayment({ status: ApplePaySession.STATUS_SUCCESS });
            const coinsWithBonus = parseInt(self.form.coins) + self.calculate_bonus;
            self.response = self.$t('shop2.success_payment', {
              orderId,
              coins: coinsWithBonus,
              character: self.form_character_c,
            });
          } catch (err) {
            PaymentSystemLogger.error('apple_pay', 'payment_authorized_failed', err);
            appleSdkSession.completePayment({ status: ApplePaySession.STATUS_FAILURE });
            self.displayPaymentError(err);
          } finally {
            self.$store.dispatch('set_modal_loading', false);
            self.btn_disabled = false;
          }
        };

        appleSdkSession.oncancel = () => {
          PaymentSystemLogger.info('apple_pay', 'user_cancelled');
          self.$store.dispatch('set_modal_loading', false);
          self.btn_disabled = false;
        };

        PaymentSystemLogger.info('apple_pay', 'session_begin');
        appleSdkSession.begin();
      } catch (err) {
        PaymentSystemLogger.error('apple_pay', 'session_setup_failed', err);
        this.displayPaymentError(err);
        this.$store.dispatch('set_modal_loading', false);
        this.btn_disabled = false;
      }
    },

    // ─── PayPal v6 ─────────────────────────────────────────────────────────
    async setupPayPalV6Button(sdkInstance) {
      try {
        const paymentMethods = await sdkInstance.findEligibleMethods({ currencyCode: 'EUR' });
        if (!paymentMethods.isEligible('paypal')) {
          PaymentSystemLogger.warn('paypal_v6', 'setup_not_eligible');
          this.paypalV6Available = false;
          return;
        }
        const self = this;
        const paypalPaymentSession = sdkInstance.createPayPalOneTimePaymentSession({
          async onApprove(data) {
            PaymentSystemLogger.info('paypal_v6', 'on_approve', { orderId: data.orderId });
            try {
              await self.captureWalletOrder(data.orderId);
              PaymentSystemLogger.info('paypal_v6', 'order_captured', { orderId: data.orderId });
              const coinsWithBonus = parseInt(self.form.coins) + self.calculate_bonus;
              self.response = self.$t('shop2.success_payment', {
                orderId: data.orderId,
                coins: coinsWithBonus,
                character: self.form_character_c,
              });
              self.$store.dispatch('set_modal_loading', false);
              self.btn_disabled = false;
            } catch (err) {
              PaymentSystemLogger.error('paypal_v6', 'capture_failed', err);
              self.displayPaymentError(err);
              self.$store.dispatch('set_modal_loading', false);
              self.btn_disabled = false;
            }
          },
          onCancel() {
            PaymentSystemLogger.info('paypal_v6', 'user_cancelled');
            self.$store.dispatch('set_modal_loading', false);
            self.btn_disabled = false;
          },
          onError(error) {
            PaymentSystemLogger.error('paypal_v6', 'session_error', error);
            self.displayPaymentError(error);
            self.$store.dispatch('set_modal_loading', false);
            self.btn_disabled = false;
          },
        });
        this._paypalPaymentSession = paypalPaymentSession;
        this.paypalV6Available = true;
        PaymentSystemLogger.info('paypal_v6', 'setup_success');
      } catch (err) {
        PaymentSystemLogger.error('paypal_v6', 'setup_failed', err);
        this.paypalV6Available = false;
      }
    },

    async onPayPalV6ButtonClick() {
      this.errors = [];
      this.response = null;

      PaymentSystemLogger.info('paypal_v6', 'button_click', {
        isFormValid: this.isFormValid,
        isReady: this.isWalletPaymentReady('paypal_v6'),
      });

      if (!this.isFormValid) {
        PaymentSystemLogger.warn('paypal_v6', 'form_invalid', {
          errors: this.formErrorMessages,
        });
        this.errors = this.formErrorMessages;
        return;
      }
      if (!this.isWalletPaymentReady('paypal_v6')) {
        PaymentSystemLogger.warn('paypal_v6', 'wallet_not_ready');
        this.errors = [this.$t('shop2.paypal_initializing')];
        return;
      }

      this.$store.dispatch('set_modal_loading', true);
      this.btn_disabled = true;

      try {
        const createOrderPromise = this.createPayPalV6Order();
        await this._paypalPaymentSession.start({ presentationMode: 'auto' }, createOrderPromise);
      } catch (err) {
        PaymentSystemLogger.error('paypal_v6', 'session_start_failed', err);
        this.displayPaymentError(err);
        this.$store.dispatch('set_modal_loading', false);
        this.btn_disabled = false;
      }
    },

    async createPayPalV6Order() {
      const payload = this.getPayPalOrderPayload('paypal_v6');
      const response = await axios.post(`${cfg_axios.base_url}/paypal/orders`, payload, {
        headers: { ...cfg_axios.headers, 'Content-Type': 'application/json' },
      });
      return { orderId: response.data.id };
    },

    // ─── Shared wallet helpers ─────────────────────────────────────────────
    getPayPalOrderPayload(paymentMethod) {
      const base = {
        intent: 'CAPTURE',
        purchaseUnits: [
          {
            amount: {
              currencyCode: 'EUR',
              value: this.price.toString(),
              breakdown: {
                itemTotal: { currencyCode: 'EUR', value: this.price.toString() },
              },
            },
            description: `${this.item.name} x${this.form.coins}`,
          },
        ],
        paymentData: {
          character: this.form_character_c,
          coins: parseInt(this.form.coins, 10),
          server: parseInt(this.form_server_c, 10),
          email: this.form.email,
          payment_method: paymentMethod,
        },
      };
      if (paymentMethod === 'google_pay') {
        base.paymentSource = {
          googlePay: {
            attributes: { verification: { method: 'SCA_WHEN_REQUIRED' } },
          },
        };
      } else if (paymentMethod === 'apple_pay') {
        base.paymentSource = {
          applePay: {
            attributes: { verification: { method: 'SCA_WHEN_REQUIRED' } },
          },
        };
      }
      return base;
    },

    async createWalletOrder(orderPayload) {
      const response = await axios.post(`${cfg_axios.base_url}/paypal/orders`, orderPayload, {
        headers: { ...cfg_axios.headers, 'Content-Type': 'application/json' },
      });
      return response.data;
    },

    async captureWalletOrder(orderId) {
      const response = await axios.post(
        `${cfg_axios.base_url}/paypal/orders/${orderId}/capture`,
        {},
        { headers: { ...cfg_axios.headers, 'Content-Type': 'application/json' } }
      );
      if (
        (response.data && response.data.status === 'COMPLETED') ||
        (response.data && response.data.id)
      ) {
        return response.data;
      }
      throw new Error(this.$t('shop2.capture_failed_invalid_response'));
    },

    isWalletPaymentReady(paymentSystem) {
      switch (paymentSystem) {
        case 'google_pay':
          return !!(
            this.googlePayAvailable &&
            this._googlePaySession &&
            this._googlePayConfig &&
            this._paymentsClient
          );
        case 'apple_pay':
          return !!(
            this.applePayAvailable &&
            this._applePaySession &&
            typeof this._applePaySession.formatConfigForPaymentRequest === 'function' &&
            this._applePayDetails?.config
          );
        case 'paypal_v6':
          return !!(this.paypalV6Available && this._paypalPaymentSession);
        default:
          return false;
      }
    },

    safeApplePayCanMakePayments() {
      if (!window.ApplePaySession || typeof ApplePaySession.canMakePayments !== 'function') {
        return false;
      }
      try {
        return ApplePaySession.canMakePayments();
      } catch (err) {
        return false;
      }
    },

    displayPaymentError(err) {
      if (err.response?.data?.messages) {
        this.errors = Object.values(err.response.data.messages);
      } else if (err.response?.data?.error) {
        this.errors = [err.response.data.message || err.response.data.error];
      } else if (err.message) {
        this.errors = [err.message];
      } else {
        this.errors = [this.$t('shop2.payment_error_generic')];
      }
    },

    // ─── DOM helpers ───────────────────────────────────────────────────────
    waitForContainer(containerId, callback) {
      const existing = document.getElementById(containerId);
      if (existing) {
        callback();
        return;
      }
      const observer = new MutationObserver((mutations, obs) => {
        const container = document.getElementById(containerId);
        if (container) {
          obs.disconnect();
          this.cleanupObserver(containerId);
          callback();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      this._observers = this._observers || {};
      this._observers[containerId] = observer;
      setTimeout(() => {
        if (this._observers && this._observers[containerId]) {
          this._observers[containerId].disconnect();
          delete this._observers[containerId];
        }
      }, 10000);
    },

    cleanupObserver(containerId) {
      if (this._observers && this._observers[containerId]) {
        this._observers[containerId].disconnect();
        delete this._observers[containerId];
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // ─── Recaptcha ─────────────────────────────────────────────────────────
    recaptchaVerified(recaptcha) {
      this.captcha = recaptcha;
    },
    recaptchaExpired() {
      if (this.env === 'production') {
        this.captcha = false;
        this.$refs.vueRecaptcha.reset();
      }
    },
    recaptchaFailed() {
      this.captcha = false;
    },

    isValidCharacterName(name) {
      if (!name || typeof name !== 'string') return false;
      return this.character_name_regex.test(name);
    },

    // ─── Form submit ───────────────────────────────────────────────────────
    async submitWalletPaymentIfSelected() {
      const paymentSystem = String(this.form.payment_system || '');
      const handlerName = WALLET_PAYMENT_HANDLERS[paymentSystem];
      if (!handlerName) return false;
      await this[handlerName]();
      return true;
    },

    async form_submit() {
      if (await this.submitWalletPaymentIfSelected()) return;

      this.$store.dispatch('set_modal_loading', true);
      this.btn_disabled = true;
      this.errors = [];
      this.response = null;
      this.response_url = null;

      if (this.form.payment_system === 'ukraine') {
        this.ua_maintenance = true;
        this.$store.dispatch('set_modal_loading', false);
        setTimeout(() => {
          this.btn_disabled = false;
          this.ua_maintenance = false;
        }, 15000);
        return;
      }

      if (this.env !== 'development') {
        if (!this.captcha) {
          this.errors.push(this.$t('shop.captcha_required'));
          setTimeout(() => {
            this.btn_disabled = false;
            this.errors = [];
          }, 3000);
          this.$store.dispatch('set_modal_loading', false);
          return;
        }
      }

      if (this.errors.length > 0) {
        this.$store.dispatch('set_modal_loading', false);
        return false;
      }

      const form_data = new FormData(this.$refs.form);

      await axios
        .post(cfg_axios.base_url + '/payment/init', form_data, {
          headers: cfg_axios.headers,
        })
        .then(response => {
          if (response.data.url && response.data.message) {
            this.response = response.data.message;
            this.response_url = response.data.url;
            setTimeout(() => {
              let newWindow = window.open(response.data.url, '_blank');
              if (newWindow == null || typeof newWindow == 'undefined') {
                this.errors.push(this.$t('shop.popup_blocked_error'));
                this.response_url = response.data.url;
              }
            }, 2500);
          } else {
            this.response = response.data;
          }
        })
        .catch(error => {
          this.errors.push(
            error.response.data.messages[Object.keys(error.response.data.messages)[0]]
          );
        })
        .finally(() => {
          this.recaptchaExpired();
          setTimeout(() => {
            this.btn_disabled = false;
            this.errors = [];
            this.response = null;
          }, 10000);
          this.$store.dispatch('set_modal_loading', false);
        });
    },
  },
};
</script>

<style scoped>
/*noinspection ALL*/
.price-width {
  min-width: 48px;
  max-width: 60px;
  overflow: hidden;
  white-space: nowrap;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  top: -5px;
  left: 105%;
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.field__ico_w-24 {
  width: 24px !important;
}

.field__title {
  margin-top: 5px;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.ua_blue {
  color: #005bbb;
}

.ua_yellow {
  padding: 10px;
  margin: 0 0 10px;
  background: #ffd500;
  font-weight: bold;
}

.google-pay-section,
.apple-pay-section,
.paypal-v6-section {
  padding: 15px 0 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.google-pay-button-container,
.apple-pay-button-container,
.paypal-v6-button-container {
  display: flex;
  justify-content: center;
  min-height: 40px;
  margin-bottom: 10px;
  max-width: 300px;
}

#google-pay-button :deep(> div) {
  background: transparent !important;
}

.payment-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.google-pay-unavailable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #856404;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  max-width: 300px;
}

.google-pay-unavailable-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

apple-pay-button {
  --apple-pay-button-width: 240px;
  --apple-pay-button-height: 40px;
  --apple-pay-button-border-radius: 4px;
  --apple-pay-button-padding: 0;
  display: inline-block;
}
</style>
